import React from 'react';

const ApolloError = () => {
  return (
    <div className='error-message-box'>
      <div>Something went wrong - Please try again later.</div>
      <div>
        If the problem continues, contact <a href='mailto:VIP@isaca.org'>VIP@isaca.org</a>.
      </div>
    </div>
  );
};

export default ApolloError;
